import Jumbotron from './Jumbotron';
const Research = ()=> {
    return ( 
        <>
        <Jumbotron />
        <div className="page-padd mt-4">
        <div className="card">
                <div className="card-header">Research</div>
                <div className="card-body">
                  <div className="card-text">
                    Professor Ebrahimi’s research includes Managers Acquaintance with Technology, Website and System Analysis, Programming Language, and System Design.
                  </div>
                  <div className="card-text">
                    Dr. Ebrahimi’s works have been published in various journals as well as national and international conference proceedings, such as the International Journal of Applied Management and Technology, Journal of Educational Technology Systems, International Journal of Learning, and Association for Computing Machinery/Computer Science Education.
                  </div>
                  <div className="card-text">
                    Professor Ebrahimi also invented: Web VPCL (with USPTO).
                  </div>
                  <div className="card-text">
                    Alongside Dr. Ebrahimi's independent research, he has mentored students from SUNY Old Westbury's Business & Computer Club to research the health benefits and use cases of the Jerusalem Artichoke, better known as the Sunchoke, which are grown at SUNY Old Westbury's garden.
                  </div>
                  <div className="text-center mt-5">
                    <a href="https://groweatheal.com/" target="_blank" className="btn btn-primary text-white mr-3">Link to the Sunchoke Research Website</a>
                    <a href="https://scholarworks.waldenu.edu/ijamt/" target="_blank" className="btn btn-primary text-white">Link to Dr. Ebrahimi's Research</a>
                </div>
                </div>
              </div>
            <div className="mt-3">
                <iframe frameBorder="0" height="300" title="myFrame"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
                    className="iframeStyle">
                </iframe>
            </div>
        </div>
        </>
     );
}

export default Research;